export class EstadoOrdenInventario {
  id: number;
  estado: string;
}